import { PermissionT } from "../types";

export const nevadaSeller = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "nevada_seller");
  return !!p;
};

export default nevadaSeller;
